import { render } from "./PageFormKontakDarurat.vue?vue&type=template&id=e16c2604"
import script from "./PageFormKontakDarurat.vue?vue&type=script&lang=js"
export * from "./PageFormKontakDarurat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__